import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BaseTeamCostSummaryItem } from '@macs-frontend/features/company-management/team-cost/team-cost.types';
import { FinancialUtils } from '@macs-frontend/features/shared';

@Component({
  selector: 'md-summary',
  templateUrl: './summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryComponent implements OnInit {
  @Input() items: BaseTeamCostSummaryItem[] = [];
  @Input() showCosts = false;
  @Input() currencySign = '';

  constructor() {}

  ngOnInit(): void {}

  calculateMargin(billablePrice: number | undefined, unitPrice: number | undefined) {
    if (billablePrice === undefined) {
      return NaN;
    }

    let realUnitPrice = 0;
    if (unitPrice !== undefined) {
      realUnitPrice = unitPrice;
    }

    return FinancialUtils.calcMargin(billablePrice, realUnitPrice, 2);
  }
}
